import { kebabCase } from 'lodash';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { IconCaret, H5 } from '@upsolve/ui';

import * as DTI from '../../../utils/dataTestIds';

const TableOfContents = ({ sectionHeaders = [] }) => {
  const [tocVisible, setTocVisible] = useState(false);
  return (
    <TableOfContentsNav tocVisible={tocVisible} dataTestId={DTI.TABLE_OF_CONTENTS}>
      <div className="toc-header"  onClick={() => setTocVisible(!tocVisible)}>
        <div className="toc-caret">
          <IconCaret />
        </div>
        <H5 as="p">Table of Contents</H5>
      </div>
      <ul className="toc-list" onClick={(e) => {
        if (!tocVisible) setTocVisible(true);
      }}>
        {sectionHeaders.map((header, headerIndex) => (
          <li key={headerIndex}>
            <a aria-busy="false" href={`#${kebabCase(header)}`}>{header}</a>
          </li>
        ))}
      </ul>
    </TableOfContentsNav>
  );
}

const TableOfContentsNav = styled.nav.attrs(props => ({
  'data-test-id': props.dataTestId,
}))`
  .toc-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.colors.white[300]};
    padding: 0.25em 0;
    cursor: pointer;
    h5, p {
      margin: 0;
      padding: 0;
    }
    & > div.toc-caret {
      color: ${props => props.theme.colors.brand[500]};
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0.25em;
      margin-right: 0.5em;
      border: 2px solid ${props => props.theme.colors.brand[700]};
      border-radius: 6px;
      svg {
        margin-top: 1px;
        height: 12px;
        width: 12px;
        path {
          fill: ${props => props.theme.colors.brand[500]};
        }
        transition: 400ms;
        transform: rotate(${props => props.tocVisible ? '180deg' : '0deg'});
      }
    }
  }
  & > ul.toc-list {
    padding: 0.25em 0;
    list-style-type: none;
    overflow: hidden;
    height: ${props => props.tocVisible ? 'initial' : '82px'};
    ${props => !props.tocVisible
      ? css`
        &::before {
          position: absolute;
          content: "";
          height: 82px;
          width: 640px; // TODO: Constrain this somehow to max width
          background: linear-gradient(0, white, transparent);
          @media(max-width: 45em) {
            width: 100%;
            left: 0;
            right: 0;
          }
        }
      `
      : ''}
    a {
      pointer-events: ${props => props.tocVisible ? 'initial' : 'none'};
    }
  }
  li {
    list-style-type: none;
    margin-left: 0;
    padding-left: 0;
    & > a {
      color: ${props => props.theme.colors.brand[500]};
    }
    &::before {
      content: '•';
      margin-right: 10px;
      color: ${props => props.theme.colors.white[100]};
    }
    &:hover {
      cursor: pointer;
    }
  }
`;

export default TableOfContents;
